import { useEffect } from 'react';
import { checkPlatform } from '../utils/helper';

export const useWebViewMessageListener = (handler: (event: MessageEvent) => void) => {
  const isInIframe = window.self !== window.top;
  useEffect(() => {
    const receiver =
      checkPlatform() === 'android' && !isInIframe
        ? document
        : window;

    const listener: EventListener = (event) => {
      handler(event as MessageEvent);
    };

    receiver.addEventListener('message', listener);

    return () => {
      receiver.removeEventListener('message', listener);
    };
  }, [handler, isInIframe]);
};